import { Fragment } from 'react';
import type { FC } from 'react';
import type { PegaCustom } from 'slate';

import { hasProp } from '@pega/cosmos-react-core';

import { nodeRenderer, leafRenderer } from './utils/renderers';

type CosmosNode = PegaCustom.Element | PegaCustom.Text;

const getNode = (node: CosmosNode, index: number) => {
  if (hasProp(node, 'children')) {
    const children: JSX.Element[] = node.children.map((childNode, i) => getNode(childNode, i));
    return <Fragment key={index}>{nodeRenderer({ ...node, children })}</Fragment>;
  }
  return <Fragment key={index}>{leafRenderer(node)}</Fragment>;
};

export interface RichTextTreeRendererProps {
  nodes: CosmosNode[];
}

export const RichTextTreeRenderer: FC<RichTextTreeRendererProps> = ({ nodes }) => {
  return <>{nodes.map((node, i) => getNode(node, i))}</>;
};
